import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_EXIT_PASS_REQUESTS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.EDIT_EXIT_PASS_REQUEST:
      return { ..._.mapKeys(action.payload, "Id") };

    case type.CREATE_EXIT_PASS_REQUEST:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_EXIT_PASS_REQUEST:
      return { ..._.mapKeys(action.payload, "Id") };
    // case type.FETCH_EXIT_PASS_REQUEST:
    //   return { ...state, [action.payload.Id]: action.payload };
    // case type.CREATE_EXIT_PASS_REQUEST:
    //   return { ...state, [action.payload.Id]: action.payload };
    // case type.EDIT_EXIT_PASS_REQUEST:
    //   return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_EXIT_PASS_REQUEST:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
